import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {EngineTabTypes} from '../../search-engine/models/engine-tab-types.enum';
import {HolidaySearchPageModule} from './holiday-search-page/holiday-search-page.module';
import {HolidaySearchComponent} from './holiday-search-page/holiday-search.component';

const routes: Routes = [
  {
    data: {name: 'Ricerca Vacanze', type: EngineTabTypes.Holiday, canNavigate: false},
    path: 'ricerca/:destinationId/:airportId/destinazione/:destinationName/aeroporto/:airportName/il/:departureDate/eta/:ages',
    component: HolidaySearchComponent
  },
  {
    data: {name: 'Dettaglio Vacanza', type: EngineTabTypes.Holiday, canNavigate: false},
    path: 'dettaglio',
    loadChildren: () => import('./holiday-detail-page/holiday-detail-page.module').then(m => m.HolidayDetailPageModule)
  },
  {
    data: {name: 'Booking Vacanze', type: EngineTabTypes.Holiday, canNavigate: false},
    path: 'booking',
    loadChildren: () => import('./holiday-booking-page/holiday-booking-page.module').then(m => m.HolidayBookingPageModule)
  }
];

@NgModule({
  imports: [
    HolidaySearchPageModule,
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class HolidayModule {
}
